export enum RouteNames {
    ////////////////////////////////////////
    //    /users
    ////////////////////////////////////////
    POST_USERS = 'post_users',
    GET_USER = 'get_user',
    GET_USER_STATUS = 'get_user_status',
    POST_LOGIN_LINK = 'send_login_link',
    POST_EMAIL_CONFIRMATION = 'send-email-confirmation',

    ////////////////////////////////////////
    //    /sync-topics
    ////////////////////////////////////////
    GET_TEAM_UPDATES = 'get_team_updates',
    GET_TEAM_TOPIC_STATE = 'get_team_topic_state',
    GET_GLOBAL_TOPIC_STATE = 'get_global_topic_state',

    ////////////////////////////////////////
    //    /client-authenticate
    //    /user-authenticate
    //    /bats-user-authenticate
    ////////////////////////////////////////
    POST_CLIENT_AUTHENTICATE = 'post_client_authenticate',
    POST_USER_AUTHENTICATE = 'post_user_authenticate',
    // THIS IS DIFFERENT FROM EDEN
    POST_USER_AUTHENTICATE_FROM_TOKEN = 'post_user_authenticate_from_token',

    ////////////////////////////////////////
    //    /provider/:provider/user-authenticate
    ////////////////////////////////////////
    POST_PROVIDER_USER_AUTHENTICATE = 'post_provider_user_authenticate',

    ////////////////////////////////////////
    //    /teams
    ////////////////////////////////////////
    POST_TEAMS = 'post_teams',
    PATCH_TEAM = 'patch_team',
    GET_TEAM = 'get_team',
    GET_ME_TEAM_STATS = 'get_me_team_stats',
    GET_MESSAGING_CHANNEL = 'get_messaging_channel',
    POST_TEAM_AVATAR_IMAGE = 'post_team_avatar_image',
    DELETE_TEAM_AVATAR_IMAGE = 'delete_team_avatar_image',
    GET_TEAM_AVATAR_IMAGE = 'get_team_avatar_image',
    GET_TEAM_NOTIFICATION_SETTING = 'get_team_notification_setting',
    PATCH_TEAM_NOTIFICATION_SETTING = 'patch_team_notification_setting',
    POST_TEAM_HIGH_SCHOOL_INFO = 'post_team_high_school_info',
    GET_TEAM_HIGH_SCHOOL_INFO = 'get_team_high_school_info',
    GET_TEAM_EXTERNAL_ASSOCIATIONS = 'get_team_external_associations',
    GET_PUBLIC_TEAM_SUMMARY = 'get_public_team_summary',
    PATCH_ROSTER_ROLLOVER = 'patch_roster_rollover',
    POST_MAXPREPS_TEAM_IMPORT = 'post_maxpreps_team_import',
    POST_ME_BATS_IMPORT_INITIATE = 'post_me_bats_import_initiate',

    ////////////////////////////////////////
    //    /teams/:owningTeamId/opponent
    ////////////////////////////////////////
    POST_OPPONENT_TEAM = 'post_opponent_team',
    PATCH_OPPONENT_TEAM = 'patch_opponent_team',
    GET_OPPONENT_TEAM = 'get_opponent_team',

    ////////////////////////////////////////
    //    /teams/:owningTeamId/opponent
    ////////////////////////////////////////
    POST_OPPONENT_TEAM_IMPORT = 'post_opponent_team_import',
    POST_OPPONENT_TEAM_LEGACY_IMPORT = 'post_opponent_team_legacy_import',

    ////////////////////////////////////////
    //    /teams/:teamID/schedule
    ////////////////////////////////////////
    GET_SCHEDULE_EVENTS = 'get_schedule_events',
    GET_EVENT = 'get_event',
    POST_SCHEDULE_EVENTS = 'post_schedule_events',
    PATCH_SCHEDULE_EVENT = 'patch_schedule_event',
    DELETE_SCHEDULE_EVENT = 'delete_schedule_event',
    DELETE_SCHEDULE_EVENT_SERIES = 'delete_schedule_event_series',
    GET_EVENT_RSVP = 'get_event_rsvp',
    PUT_EVENT_RSVP_FOR_PLAYER = 'put_event_rsvp_for_player',
    PUT_EVENT_RSVP_FOR_USER = 'put_event_rsvp_for_user',
    GET_EVENT_BATS_SCOREKEEPING_DATA = 'get_event_bats_scorekeeping_data',
    POST_SCHEDULE_EVENT_SERIES = 'post_schedule_event_series',
    GET_SCHEDULE_EVENT_SERIES = 'get_schedule_event_series',
    GET_SCHEDULE_EVENT_SERIES_EVENTS = 'get_schedule_event_series_events',
    PATCH_SCHEDULE_EVENT_SERIES = 'patch_schedule_event_series',
    POST_REIMPORT_EXTERNAL_EVENTS = 'post_reimport_external_events',
    GET_SCHEDULE_EVENT_VIDEO_STREAM = 'get_schedule_event_video_stream',
    GET_STREAM_ASSET_PLAYBACK_DATA = 'get_stream_asset_playback_data',
    GET_ALL_STREAM_ASSET_METADATA_FOR_SCHEDULE_EVENT = 'get_all_schedule_event_stream_asset_metadata',
    PATCH_STREAM_ASSET_METADATA = 'patch_stream_asset_metadata',
    GET_OPPONENT_TEAMS = 'get_opponent_teams',
    ////////////////////////////////////////
    //    /teams/:teamId/video-stream
    ////////////////////////////////////////
    GET_ALL_TEAM_STREAM_ASSET_METADATA = 'get_all_team_stream_asset_metadata',

    ////////////////////////////////////////
    //    /teams/:teamID/players
    ////////////////////////////////////////
    GET_PLAYERS = 'get_players',
    POST_PLAYERS = 'post_players',
    PATCH_PLAYER = 'patch_player',
    PATCH_PLAYER_FAMILY_RELATIONSHIPS = 'patch_player_family_relationships',
    DELETE_PLAYER = 'delete_player',

    ////////////////////////////////////////
    //    /teams/:teamID/fans
    ////////////////////////////////////////
    GET_TEAM_FANS = 'get_team_fans',

    ////////////////////////////////////////
    //    /teams/:teamID/players/:playerID/stats
    ////////////////////////////////////////
    GET_PLAYER_STATS = 'get_player_stats',

    ////////////////////////////////////////
    //   /teams/:teamID/video-clips/player/:playerId/clips
    ////////////////////////////////////////
    GET_ALL_VIDEO_CLIP_METADATA_FOR_PLAYER = 'get_player_video_clip_asset_metadata',

    /////////////////////////////////////////////////////////////////////////
    //    /teams/:teamId/video-clips/playable-clip/:clipMetadataId/clip    //
    /////////////////////////////////////////////////////////////////////////
    GET_VIDEO_CLIP = 'get_video_clip',
    ////////////////////////////////////////
    //   /teams/:teamID/public-team-profile-id
    ////////////////////////////////////////
    GET_TEAM_PUBLIC_PROFILE_ID = 'get_team_public_profile_id',
    ////////////////////////////////////////
    //    /teams/:teamId/schedule/events/:eventID/player-stats
    ////////////////////////////////////////
    GET_PLAYER_GAME_STATS = 'get_player_game_stats',

    ////////////////////////////////////////
    //    /teams/:teamID/users
    ////////////////////////////////////////
    GET_TEAM_USERS = 'get_team_users',

    ////////////////////////////////////////
    //    /teams/:teamID/community-pass
    ////////////////////////////////////////
    POST_TEAM_COMMUNITY_PASS = 'post_team_community_pass',

    ////////////////////////////////////////
    //    /teams/:teamID/managers
    ////////////////////////////////////////
    PUT_TEAM_MANAGER = 'put_manager',

    ////////////////////////////////////////
    //    /teams/:teamID/managers/:userID
    ////////////////////////////////////////
    DELETE_MANAGER = 'delete_manager',

    ////////////////////////////////////////
    //    /player-attributes/:playerId
    ////////////////////////////////////////
    GET_BATS_PLAYER_ATTRIBUTES = 'get_bats_player_attributes',
    POST_BATS_PLAYER_ATTRIBUTES = 'post_bats_player_attributes',
    PATCH_BATS_PLAYER_ATTRIBUTES = 'patch_bats_player_attributes',

    ////////////////////////////////////////
    //    /teams/:teamID/associations
    ////////////////////////////////////////
    GET_TEAM_ASSOCIATIONS = 'get_team_associations',

    ////////////////////////////////////////
    //    /teams/:teamID/associations
    ////////////////////////////////////////
    GET_TEAM_RELATIONSHIPS = 'get_team_relationships',

    ////////////////////////////////////////
    //    /me
    ////////////////////////////////////////
    GET_ME_USER = 'get_me_user',
    GET_ME_TEAM = 'get_me_team',
    GET_ME_PERMISSIONS = 'get_me_permissions',
    GET_ME_PERMISSIONS_V2 = 'get_me_permissions_v2',
    GET_ME_PERMISSIONS_V2_ALL = 'get_me_permissions_v2_all',
    GET_ME_TWILIO_CHAT = 'get_me_twilio_chat',
    GET_ME_EXTERNAL_CALENDAR_SYNC_URL = 'get_me_external_calendar_sync_url',
    GET_ME_PENDING_TEAMS = 'get_me_pending_teams',
    GET_ME_ORGANIZATIONS = 'get_me_organizations',
    GET_ME_SUBSCRIPTION_INFORMATION = 'get_me_subscription_information',
    PATCH_ME_PASSWORD = 'patch_me_password',
    POST_ME_FIREBASE_TOKEN = 'post_me_firebase_token',
    POST_ME_CLIENT_BACKUP = 'post_me_client_backup',
    DELETE_ME_RELATIONSHIP_REQUESTS = 'delete_me_relationship_requests',

    ////////////////////////////////////////
    //    /channels
    ////////////////////////////////////////
    POST_MESSAGING_CHANNEL_IMAGE = 'post_messaging_channel_image',
    GET_MESSAGING_CHANNEL_IMAGE = 'get_messaging_channel_image',
    GET_MESSAGING_CHANNEL_IMAGES = 'get_messaging_channel_images',
    POST_MESSAGING_CHANNEL_VIDEO = 'post_messaging_channel_video',
    GET_MESSAGING_CHANNEL_VIDEO = 'get_messaging_channel_video',
    GET_MESSAGING_CHANNEL_VIDEOS = 'get_messaging_channel_videos',
    DELETE_MESSAGING_CHANNEL_MEDIA = 'delete_messaging_media',

    ////////////////////////////////////////
    //    /simple-scorekeeping-configs
    ////////////////////////////////////////
    GET_SIMPLE_SCOREKEEPING_CONFIGS = 'get_simple_scorekeeping_configs',

    ////////////////////////////////////////
    //    /teams/:teamID/simple-scorekeeping/config
    ////////////////////////////////////////
    GET_SIMPLE_SCOREKEEPING_TEAM_CONFIG = 'get_simple_scorekeeping_team_config',
    POST_SIMPLE_SCOREKEEPING_TEAM_CONFIG = 'post_simple_scorekeeping_team_config',

    ////////////////////////////////////////
    //    /teams/:teamID/schedule/simple-scorekeeping
    ////////////////////////////////////////
    GET_SIMPLE_SCOREKEEPING_GAME_DATA = 'get_simple_scorekeeping_game_data',
    POST_SIMPLE_SCOREKEEPING_GAME_DATA = 'post_simple_scorekeeping_game_data',
    PATCH_SIMPLE_SCOREKEEPING_GAME_DATA = 'patch_simple_scorekeeping_game_data',
    POST_SIMPLE_SCOREKEEPING_GAME_DATA_AFTER_GAME = 'post_simple_scorekeeping_game_data_after_game',
    PATCH_SIMPLE_SCOREKEEPING_GAME_DATA_AFTER_GAME = 'patch_simple_scorekeeping_game_data_after_game',
    POST_SIMPLE_SCOREKEEPING_SHARE_TIME = 'post_simple_scorekeeping_share_time',

    ////////////////////////////////////////
    //    /teams/:teamID/schedule/batch-simple-scorekeeping-data
    ////////////////////////////////////////
    GET_BATCH_SIMPLE_SCOREKEEPING_GAME_DATA_RESULT = 'get_batch_simple_scorekeeping_game_data_result',

    ////////////////////////////////////////
    //    /teams/:teamID/game-summaries
    ////////////////////////////////////////
    GET_TEAM_GAME_SUMMARIES = 'get_team_game_summaries',
    GET_TEAM_GAME_SUMMARY = 'get_team_game_summary',

    ////////////////////////////////////////
    //    /scorekeeping-data/bats/:scorekeepingDataId
    ////////////////////////////////////////
    GET_BATS_SCOREKEEPING_DATA = 'get_bats_scorekeeping_data',
    PATCH_BATS_SCOREKEEPING_DATA = 'patch_bats_scorekeeping_data',
    POST_BATS_SCOREKEEPING_DATA = 'post_bats_scorekeeping_data',
    GET_BATS_SCOREKEEPING_DATA_EVENT_IDS = 'get_bats_scorekeeping_data_event_ids',

    ////////////////////////////////////////
    //    /scorekeeping-events/bats/:scorekeepingEventId
    ////////////////////////////////////////
    GET_BATS_SCOREKEEPING_EVENT = 'get_bats_scorekeeping_event',
    POST_BATS_SCOREKEEPING_EVENT = 'post_bats_scorekeeping_event',

    ////////////////////////////////////////
    //    /pregame-data/:pregameDataId
    ////////////////////////////////////////
    POST_PREGAME_DATA = 'post_pregame_data',
    GET_PREGAME_DATA = 'get_pregame_data',

    ////////////////////////////////////////
    //    /bsb
    ////////////////////////////////////////
    GET_BSB_TEAMS = 'get_bsb_teams',
    POST_TEAM_IMPORT = 'post_team_import',

    ////////////////////////////////////////
    //   /search
    ////////////////////////////////////////
    OPPONENT_SEARCH = 'opponent_search',
    MAXPREPS_SCHOOL_SEARCH = 'get_maxpreps_school_search',

    ////////////////////////////////////////
    //   /event
    ////////////////////////////////////////
    GET_EVENT_BEST_STREAM_ID = 'get_event_best_stream_id',

    ////////////////////////////////////////
    //   /game_streams
    ////////////////////////////////////////
    GET_GAME_STREAM = 'get_game_stream',
    GET_GAME_STREAM_EVENTS = 'get_game_stream_events',
    GET_GAME_STREAM_VIEWER_PAYLOAD_LITE = 'get_game_stream_viewer_payload_lite',
    PUT_GAME_STAT_EDIT_COLLECTION = 'put_game_stat_edit_collection',
    GET_GAME_STAT_EDIT_COLLECTION = 'get_game_stat_edit_collection',
    ////////////////////////////////////////
    //   /bats_starting_lineup
    ////////////////////////////////////////
    GET_BATS_STARTING_LINEUP = 'get_bats_starting_lineup',
    POST_BATS_STARTING_LINEUP = 'post_bats_starting_lineup',
    PATCH_BATS_STARTING_LINEUP = 'patch_bats_starting_lineup',
    GET_LATEST_BATS_STARTING_LINEUP = 'get_latest_bats_starting_lineup',

    ////////////////////////////////////////
    //   /players/:playerID/profile-photo
    ////////////////////////////////////////
    GET_PLAYER_PROFILE_PHOTO = 'get_player_profile_photo',

    ////////////////////////////////////////
    //   /organizations/:orgID
    ////////////////////////////////////////
    GET_ORGANIZATION = 'get_organization',
    GET_ORGANIZATION_TEAMS = 'get_organization_teams',
    GET_ORGANIZATION_USERS = 'get_organization_users',
    PATCH_ORGANIZATION_SCHEDULE_EVENT = 'patch_organization_schedule_event',
    POST_ORGANIZATION_SCHEDULE_EVENT = 'post_organization_schedule_event',
    POST_ORGANIZATION_SCHEDULE_EVENT_BULK = 'post_organization_schedule_event_bulk',
    GET_ORGANIZATION_SCHEDULE_EVENT_BULK_UPLOAD_TEMPLATE = 'get_organization_schedule_event_bulk_upload_template',
    POST_ORGANIZATION_SCHEDULE_EVENT_BULK_VALIDATE = 'post_organization_schedule_event_bulk_validate',
    POST_ORGANIZATION_TEAMS = 'post_organization_teams',
    GET_ORGANIZATION_LEADERBOARDS = 'get_organization_leaderboards',
    GET_ORGANIZATION_SCHEDULE_EVENT_RESULTS_EXPORT = 'get_organization_schedule_event_results_export',

    ////////////////////////////////////////
    //   /athlete-profile/*
    ////////////////////////////////////////
    GET_ATHLETE_PROFILE_BY_HANDLE_PUBLIC = 'get_athlete_profile_by_handle_public',
    GET_ATHLETE_PROFILE_CLIPS_PUBLIC = 'get_athlete_profile_clips_public',
    GET_ATHLETE_PROFILE_AUTHENTICATED_CLIP_URL_PUBLIC = 'get_athlete_profile_authenticated_clip_url_public',
    GET_ATHLETE_PROFILE_CAREER_STATS_PUBLIC = 'get_athlete_profile_career_stats_public',
}
